module.exports = __webpack_public_path__ + "static/stats-banner-parallax-bc708269ea8691194335ffd70f769734.jpg";